export function fbqWrapper(...args) {
  if (window.fbq) {
    window.fbq(...args)
  }
}
